module.exports = __webpack_public_path__ + "static/media/userNewConversation.93c4dca5.svg";